'use client';

import { useIsMobile } from '@/hooks/use-is-mobile';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { Carousel, CarouselApi, CarouselContent, CarouselDots, CarouselItem } from '../ui/carousel';

export const Features = ({ features }: { features: any }) => {
  const { isMobile } = useIsMobile();
  const [api, setApi] = useState<CarouselApi | null>(null);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);

  useEffect(() => {
    if (!api) return;

    const onSelect = (emblaApi: CarouselApi) => {
      if (!emblaApi) return;

      setCanScrollPrev(api.canScrollPrev());
      setCanScrollNext(api.canScrollNext());
    };

    onSelect(api);
    api.on('reInit', onSelect).on('select', onSelect);
  }, [api]);

  if (!Array.isArray(features) || features.length === 0) {
    return null;
  }

  const mobileFeatures = features.filter((feature: any) => feature?.type?.toUpperCase() === 'M');
  const desktopFeatures = features.filter((feature: any) => feature?.type?.toUpperCase() === 'PC');
  const renderFeatures = isMobile ? mobileFeatures : desktopFeatures;

  if (renderFeatures.length === 0) {
    return null;
  }

  return (
    <div className='relative  mx-auto mt-5 max-w-site px-3 lg_mt-[60px] lg_px-0'>
      {canScrollPrev || canScrollNext ? (
        <>
          <button
            type='button'
            className={clsx(
              'hidden h-[60px] w-[60px] rounded-[50%] bg-white lg_flex lg_items-center lg_justify-center',
              'absolute left-5 top-1/2 z-[2] -translate-y-1/2',
              'shadow-[0_0_12px_0_rgba(0,0,0,.1)]',
            )}
            onClick={() => {
              api?.scrollPrev();
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='13'
              height='23'
              fill='none'
              viewBox='0 0 13 23'
            >
              <path
                fill='#4C4C4C'
                d='M10.092 1.167c.28-.27.653-.419 1.045-.419.396 0 .766.149 1.045.419a1.407 1.407 0 0 1 0 2.04l-8.49 8.21 8.494 8.21c.28.27.437.635.437 1.018 0 .387-.153.747-.437 1.018a1.5 1.5 0 0 1-1.044.418 1.5 1.5 0 0 1-1.045-.418L.549 12.435a1.407 1.407 0 0 1 0-2.04z'
              ></path>
            </svg>
          </button>
          <button
            type='button'
            className={clsx(
              'hidden h-[60px] w-[60px] rounded-[50%] bg-white lg_flex lg_items-center lg_justify-center',
              'absolute right-5 top-1/2 z-[2] -translate-y-1/2',
              'shadow-[0_0_12px_0_rgba(0,0,0,.1)]',
            )}
            onClick={() => {
              api?.scrollNext();
            }}
          >
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='13'
              height='23'
              fill='none'
              viewBox='0 0 13 23'
            >
              <path
                fill='#4C4C4C'
                d='M2.908 1.167A1.5 1.5 0 0 0 1.863.748a1.5 1.5 0 0 0-1.045.419 1.407 1.407 0 0 0 0 2.04l8.49 8.21-8.495 8.21c-.279.27-.436.635-.436 1.018 0 .387.153.747.436 1.018.28.27.649.418 1.045.418a1.5 1.5 0 0 0 1.045-.418l9.548-9.228a1.407 1.407 0 0 0 0-2.04z'
              ></path>
            </svg>
          </button>
        </>
      ) : null}
      <Carousel
        opts={{ align: 'start' }}
        setApi={setApi}
      >
        <CarouselContent className='ml-0'>
          {renderFeatures.map(({ imgUrl }) => {
            return (
              <CarouselItem
                className='pl-0 text-[0]'
                key={imgUrl}
              >
                <img
                  src={imgUrl}
                  className='h-auto w-full'
                  alt='feature'
                />
              </CarouselItem>
            );
          })}
        </CarouselContent>
        <CarouselDots
          className='mt-5 flex gap-x-1 lg_hidden'
          dotClassName='w-1.5 h-1.5 rounded-[50%] bg-e0e0e0'
          activeDotClassName='w-1.5 h-1.5 rounded-[50%] bg-black'
        />
      </Carousel>
    </div>
  );
};
